<template>
    <div>
        <SignBody/>
    </div>
</template>

<script src="./SignScreen.js"></script>